// extracted by extract-css-chunks-webpack-plugin
module.exports = {"regItem":"reg-item__regItem__3EhgY","image":"reg-item__image__LPusM","meta":"reg-item__meta__1iYBB","title":"reg-item__title__149LR"};